/**
 * Matrix -> OPBridge doc-store sync.
 *
 * History. 2026-08-11: the Matrix (CC/note/PC device registry,
 * `matrix/store.ts`) began syncing through the generic consumer doc store
 * (`PUT/GET/DELETE /docs/{consumer}/{doc_id}`) rather than OPBridge's
 * `/matrix` REST entity, which is a different concept (a routing-indirection
 * table for the Rules engine, no claims or co-ownership). It was ONE doc,
 * `matrix`, holding the whole library, pulled once per connect, higher rev
 * replacing everything.
 *
 * 2026-10-06 (S305): one doc per device and per slot, merged record by record
 * (`sync/recordDocSync.ts`, records in `matrixRecords.ts`). Whole-library
 * newest-wins lost one PC's edits whenever two PCs edited inside one sync
 * window, which is why OPBridge never replicated it; per record, both survive.
 * The old `matrix` doc is read once to migrate and left untouched.
 *
 * localStorage remains the SOURCE OF TRUTH and the offline store: no bridge,
 * no problem.
 */

import { matrixLibrary, setMatrixLibrary, matrixIsUneditedSeed } from './store.ts';
import { matrixAdapter } from './matrixRecords.ts';
import { installRecordSync, type RecordSyncHandle } from '../sync/recordSyncWiring.ts';

/** Kill switch, a DEDICATED key (not shared with projects): the bot sets it
 *  so a smoke's throwaway matrix never reaches a real bridge. */
const DISABLE_KEY = 'opbuttons.matrixSync.disabled';
const MEMORY_KEY = 'opbuttons.matrixSync.memory.v1';

let handle: RecordSyncHandle | null = null;
export function matrixSync(): RecordSyncHandle | null { return handle; }

/** Wire the reactive effects. Call once at app boot. */
export function installMatrixSync(): void {
  handle = installRecordSync({
    adapter: matrixAdapter,
    read: matrixLibrary,
    write: setMatrixLibrary,
    disableKey: DISABLE_KEY,
    memoryKey: MEMORY_KEY,
    unauthoritative: matrixIsUneditedSeed,
  });
}
